import { api } from './api';

const getCardApprovalList = async ({ customerId }) => {
  const response = await api({
    url: `Vehicles/getCardApprovalList`,
    method: 'GET',
    params: {
      customerId,
    },
  });
  return response.data;
};

const updateCardApproval = async ({ vehicleDetailId }) => {
  const response = await api({
    url: `Vehicles/updateCardApproval`,
    method: 'POST',
    data: { vehicleDetailId },
  });
  return response.data;
};

const ticketCarCardOrderServices = {
  getCardApprovalList,
  updateCardApproval,
};

export default ticketCarCardOrderServices;
